<template>
  <a-modal title="详情" :visible="showTubeView" :width="800" destroyOnClose @ok="handleOk" @cancel="closeTubeView">
    <a-modal
      title="地图"
      style="top: 20px"
      :width="800"
      v-model="mapVisible"
      @ok="mapVisible = false"
      @cancel="mapVisible = false"
    >
      <lonlat-map ref="lonlatMaps" @handleMapOk="handleMapOk"></lonlat-map>
    </a-modal>
    <!-- style="position: absolute; left: 18rem; z-index: 999; top: 3rem" -->
    <a-form-model
      class="log-form"
      :model="addOrUpdateForm"
      ref="addOrUpdateForm"
      :rules="rules"
      :label-col="{ span: 6 }"
      :wrapper-col="{ span: 14 }"
    >
      <a-row class="form-row" type="flex" justify="center" :gutter="4">
        <a-col :md="12" :sm="24">
          <p>巡检事项 : {{ addOrUpdateForm.taskName }}</p>
        </a-col>
        <a-col :md="12" :sm="24">
          <p>负责人 : {{ addOrUpdateForm.principalName }}</p>
        </a-col>
        <a-col :md="12" :sm="24">
          <p>协办人 : {{ addOrUpdateForm.assistPersonName }}</p>
        </a-col>
        <a-col :md="12" :sm="24">
          <p>片区 : {{ addOrUpdateForm.zoneName }}</p>
        </a-col>

        <a-col :md="12" :sm="24">巡检周期 : {{ addOrUpdateForm.inspectionFrequency }} </a-col>
        <a-col :md="12" :sm="24">
          <p>上次巡检日期 :<span v-if="addOrUpdateForm.lastInspectionDate  !== null">{{ moment(addOrUpdateForm.lastInspectionDate ).format('YYYY-MM-DD') }}</span></p>
        </a-col>
        <a-col :md="12" :sm="24">
          <p>下次巡检日期 :<span v-if="addOrUpdateForm.nextInspectionDate  !== null">{{ moment(addOrUpdateForm.nextInspectionDate ).format('YYYY-MM-DD') }}</span></p>
        </a-col>
        <a-col :md="12" :sm="24">
          <p>计划处理时长 : {{ addOrUpdateForm.planTime }}天</p>
        </a-col>
        <a-col :md="12" :sm="24">
          <p @click="addAddress">
            地址 : <span style="color: #262daa">{{ addOrUpdateForm.address }}</span>
          </p>
        </a-col>
        <a-col :md="12" :sm="24">
          <p>任务描述 : {{ addOrUpdateForm.description }}</p>
        </a-col>
      </a-row>
    </a-form-model>
  </a-modal>
</template>
<script>
import moment from 'moment'
import addModal from './AddModal'
import LonlatMap from '../../../maintenance/EventManagement/modules/lonlatMap.vue'
export default {
  components: {
    addModal,
    LonlatMap,
  },
  props: {},
  data() {
    return {
      columns: [
        {
          title: '序号',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          },
        },
        {
          title: '任务编号',
          dataIndex: 'taskNumber',
        },
        {
          title: '开始时间',
          dataIndex: 'startTime',
        },
        {
          title: '完成时间',
          dataIndex: 'completeTime',
        },
        {
          title: '处理时长',
          dataIndex: 'processingTime',
        },
      ],
      queryOneUrl: '/pipe-network/inspection_managements',
      showTubeView: false,
      id: '',
      addOrUpdateForm: {
        // taskType: '',
        // startTime: '',
        // zoneId: '',
        // description: '',
        // address: '',
        // assistPersons: [],
        // principal: ''
      },
      eventTypeList: [],
      assistPersonsList: [],
      currentId: '',
      mapVisible: false,
    }
  },
  computed: {
    rules() {
      return {}
    },
  },
  created() {},
  methods: {
    moment,
    handleChange(value) {
      this.addOrUpdateForm.principal = value
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },

    handleOk(e) {
      e.preventDefault()
      this.closeTubeView()
    },
    _updateForm(real, data) {
      let keys = Object.keys(real)
      let dataKeys = Object.keys(data)
      let newObject = {}
      keys.map((key) => {
        if (dataKeys.includes(key)) {
          newObject[key] = data[key]
        } else {
          newObject[key] = real[key]
        }
      })
      return newObject
    },
    edit(id) {
      this.showTubeView = true
      this.currentId = id

      this.$nextTick(() => {
        this.$refs.addOrUpdateForm.resetFields()
        if (id) {
          this.isUpdate = true
          this.$http
            .get(`${this.queryOneUrl}/${this.currentId}`)
            .then(({ data }) => {
              
              // this.addOrUpdateForm = { ...this._updateForm(this.addOrUpdateForm, data) }
              this.addOrUpdateForm = data
            })
            .catch(() => {})
        }
      })
    },
    closeTubeView() {
      this.showTubeView = false
      this.$refs.addOrUpdateForm.resetFields()
      this.assistPersonsList = []
    },
    addAddress() {
      this.mapVisible = true
      if (this.addOrUpdateForm.place) {
        var pointData = this.addOrUpdateForm.place.split(',')
        var newPointData = pointData.map((item) => {
          return (item = parseFloat(item))
        })
        console.log(newPointData, this.$refs) // [113.678351, 25.538859]
        this.$nextTick(() => {
          this.$refs.lonlatMaps.changepoint(newPointData)
        })
      } else {
        this.$nextTick(() => {
          this.$refs.lonlatMaps.changepoint([0, 0])
        })
      }
    },
    handleMapOk() {},
  },
}
</script>

<style lang="less" scoped>
</style>
